<template>
    <div class="block-add-partner">
      <div class="block-add-partner-container col-lg-6 col-md-12">
        <picture>
          <source srcset="/assets/Description/partners.webp" type="image/webp">
          <img
            class="block-add-partner-img"
            src="/assets/Description/partners.svg"
            loading="lazy"
            alt="about-us-icon"
            width="295"
            height="180"
          >
        </picture>
      </div>
      <div class="block-add-partner-container mb-10 col-lg-6 col-md-12">
        <h4 class="block-add-partner-container-title">{{ $t('Become a partner') }}</h4>
        <p class="block-add-partner-container-subtitle">{{ $t('Приєднайся до однієї з найбільших компаній із доставки товарів') }}</p>
        <router-link class="block-add-partner-container-link" :to="localizedRoute('/aboutpartner')">{{ $t('Become a partner') }}</router-link>
      </div>
    </div>
</template>

<script async>
  export default {
    name: 'addPartner'
  }
</script>

<style lang="scss" scoped>

.block-add-partner {
  padding: 10px;

  display: flex;
  align-items: center;

  border-radius: 15px;
  background: #fff;

  &-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    picture {
      padding: 0;
    }

    & img {
      width: 100%;
      height: 180px;
    }

    &-title {
      margin-top: 0;
      margin-bottom: 10px;
      font-size: 25px;
    }

    &-subtitle {
      margin-top: 0;
      margin-bottom: 20px;
      font-size: 16px;
    }

    &-link {
      padding: 10px 0;
      width: 100%;

      color: #fff;
      font-size: 16px;
      font-weight: 600;

      background: #F2994A;
      border-radius: 10px;
      display: block;
      max-width: 230px;

      @media (max-width: 310px) {
        padding: 10px;
      }
    }

    @media only screen and (max-width: 991px) {
      height: auto;
    }
  }

  &-img {
    object-fit: contain;
  }

  @media (max-width: 991px) {
    display: block;
    text-align: -webkit-center;
  }

  @media only screen and (max-width: 576px) {
    flex: 1 1 100%;
    max-width: 100%;
  }
}
</style>
